// FETCH ALL PROPERTIES FROM UNIT MASTER
export const FETCH_UNIT_MASTER_REQUEST = 'FETCH_UNIT_MASTER_REQUEST';
export const FETCH_UNIT_MASTER_SUCCESS = 'FETCH_UNIT_MASTER_SUCCESS';
export const FETCH_UNIT_MASTER_FAILURE = 'FETCH_UNIT_MASTER_FAILURE';

// FETCH ALL PROPERTIES FROM UNIT MASTER
export const FETCH_UNIT_MASTER_BY_COMPANYID_REQUEST = 'FETCH_UNIT_MASTER_BY_COMPANYID_REQUEST';
export const FETCH_UNIT_MASTER_BY_COMPANYID_SUCCESS = 'FETCH_UNIT_MASTER_BY_COMPANYID_SUCCESS';
export const FETCH_UNIT_MASTER_BY_COMPANYID_FAILURE = 'FETCH_UNIT_MASTER_BY_COMPANYID_FAILURE';

// CREATE PROPERTIES FOR UNIT MASTER
export const CREATE_UNIT_MASTER_REQUEST = 'CREATE_UNIT_MASTER_REQUEST';
export const CREATE_UNIT_MASTER_SUCCESS = 'CREATE_UNIT_MASTER_SUCCESS';
export const CREATE_UNIT_MASTER_FAILURE = 'CREATE_UNIT_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_UNIT_MASTER = 'CREATE_USER_FORM_UNIT_MASTER';

//UPDATE USER FORM
export const UPDATE_USER_FORM_UNIT_MASTER = 'UPDATE_USER_FORM_UNIT_MASTER';

//GET PROPERTY FROM PROPERTY TABLE
export const UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST = 'UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST';
export const UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS = 'UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS';
export const UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE = 'UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE';

//GET AREA FROM AREA TABLE
export const UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST = 'UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST';
export const UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS = 'UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS';
export const UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE = 'UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE';

// UPDATE PROPERTIES FOR UNIT MASTER
export const UPDATE_UNIT_MASTER_REQUEST = 'UPDATE_UNIT_MASTER_REQUEST';
export const UPDATE_UNIT_MASTER_SUCCESS = 'UPDATE_UNIT_MASTER_SUCCESS';
export const UPDATE_UNIT_MASTER_FAILURE = 'UPDATE_UNIT_MASTER_FAILURE';

// FETCH SINGLE UNIT
export const FETCH_SINGLE_UNIT_MASTER_REQUEST = 'FETCH_SINGLE_UNIT_MASTER_REQUEST';
export const FETCH_SINGLE_UNIT_MASTER_SUCCESS = 'FETCH_SINGLE_UNIT_MASTER_SUCCESS';
export const FETCH_SINGLE_UNIT_MASTER_FAILURE = 'FETCH_SINGLE_UNIT_MASTER_FAILURE';

// DELETE PROPERTIES FOR UNIT MASTER
export const DELETE_UNIT_MASTER_REQUEST = 'DELETE_UNIT_MASTER_REQUEST';
export const DELETE_UNIT_MASTER_SUCCESS = 'DELETE_UNIT_MASTER_SUCCESS';
export const DELETE_UNIT_MASTER_FAILURE = 'DELETE_UNIT_MASTER_FAILURE';

// USERFORM RESET

export const UNIT_MASTER_USERFORM_RESET = 'UNIT_MASTER_USERFORM_RESET';
